import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { Location } from '@angular/common';
import {
  ActivatedRoute,
  Router,
  Params,
  ParamMap,
  NavigationEnd,
  NavigationStart,
} from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { take, tap, filter } from 'rxjs/operators';

import { Student } from 'src/app/modules/lms/learningpaths/models/interfaces';
import { EmployeeService } from '../../../personnel-files/services/employee.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ProgresoTimeoutService } from 'src/app/auth/services/timeout-service';
import { IframeService } from 'src/app/shared/iframe/services/iframe.service';
import { BreadcrumbService } from 'src/app/shared/framework/navigation/services/breadcrumb.service';

@Component({
  selector: 'app-classic-sandbox',
  templateUrl: './classic-sandbox.component.html',
  styleUrls: ['./classic-sandbox.component.scss'],
})
export class ClassicSandboxComponent implements OnInit, OnDestroy {
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;

  public iframelink: string;
  public iframelinkSafe: SafeResourceUrl;

  private _subscriptions: Subscription[] = [];
  private queryStringParams: Object[] = [];
  private iframeFirstLoad = true;
  private newLoad = false;

  constructor(
    private _employeeService: EmployeeService,
    private _breadcrumbService: BreadcrumbService,
    private _authService: AuthService,
    private _timeoutService: ProgresoTimeoutService,
    private iframeService: IframeService,
    private route: ActivatedRoute,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.startWatching();

    this._subscriptions.push(
      this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe((e: NavigationEnd) => {
          for (const subscription of this._subscriptions) {
            subscription.unsubscribe();
          }

          this.newLoad = true;
          this.startWatching();
        })
    );
  }

  @HostListener('window:resize')
  resizeFrame() {
    setTimeout(() => {
      // var iframes = window.parent.document.getElementsByTagName('iframe');
      // for (let index = 0; index < iframes.length; index++) {
      //   const element = iframes[index];
      //   element.style.height = (element.contentWindow.document.body.scrollHeight) + 'px';
      // }
      try {
        (<any>window.top).initIframeResize();
        if (window.document.body) {
          window.document.body.style.height = "100%";
        }
      } catch (e) { }
    }, 500);
  }

  public startWatching() {
    this._subscriptions.push(
      this._employeeService
        .getCurrentEmployee(true)
        .pipe(take(1))
        .subscribe((student: Student) => {
          this._subscriptions.push(
            this.route.queryParamMap.subscribe((queryParams: ParamMap) => {
              for (const key of queryParams.keys) {
                const existingKeys = this.queryStringParams.filter(
                  (e) => e['key'] === key
                );
                if (existingKeys.length) {
                  for (const existingKey of existingKeys) {
                    const index = this.queryStringParams.indexOf(existingKey);
                    this.queryStringParams.splice(index, 1);
                  }
                }
                this.queryStringParams.push({
                  key: key,
                  value: queryParams.get(key),
                });
              }

              window.top.scrollTo(0, 0);
              this.constructUrl(student);
            })
          );
        })
    );
  }

  public iframeLoad(e): void {
    if (
      this.iframe &&
      this.iframe.nativeElement &&
      this.iframe.nativeElement.contentDocument &&
      this.iframe.nativeElement.contentDocument.body &&
      this.iframe.nativeElement.contentWindow &&
      this.iframe.nativeElement.contentDocument.readyState === 'complete'
    ) {
      this._timeoutService.resetTimer();

      this.iframe.nativeElement.contentDocument.body.onclick = () => {
        this._timeoutService.resetTimer();
      };

      setTimeout(() => {
        if (
          this.iframe &&
          this.iframe.nativeElement &&
          this.iframe.nativeElement.contentDocument &&
          this.iframe.nativeElement.contentDocument.readyState === 'complete'
        ) {
          this.iframeService.findAndRegisterFrames(
            this.iframe.nativeElement.contentDocument.body
          );
        }
      });

      const iframes: any =
        this.iframe.nativeElement.contentDocument.body.getElementsByTagName(
          'iframe'
        );
      for (const iframe of iframes) {
        if (
          iframe &&
          iframe.contentDocument &&
          iframe.contentDocument.body &&
          iframe.contentDocument.readyState === 'complete'
        ) {
          iframe.contentDocument.body.onclick = () => {
            const subiframes: any =
              iframe.contentDocument.body.getElementsByTagName(
                'iframe'
              );
            for (const subIframe of subiframes) {
              if (
                subIframe &&
                subIframe.contentDocument &&
                subIframe.contentDocument.body &&
                subIframe.contentDocument.readyState === 'complete'
              ) {
                subIframe.contentDocument.body.onclick = () => {
                  this._timeoutService.resetTimer();
                };
              }
            }
            this._timeoutService.resetTimer();
          };
        }
      }

      const newFrameLocation = this.iframe.nativeElement.contentWindow.location.pathname;

      if (this.iframeFirstLoad) {
        this.iframeFirstLoad = false;
      } else {
        for (const route of this.router.config) {
          if (
            (route.path === '' ||
              route.path === 'manager' ||
              route.path === 'chr' ||
              route.path === 'delegate') &&
            route.children &&
            route.children.length > 0
          ) {
            for (const childRoute of route.children) {
              try {
                if (!childRoute.data || !childRoute.data['classicpath']) {
                  continue;
                }

                let classicData: string = childRoute.data['classicpath'];
                let flag = true;
                if (
                  classicData.indexOf('adhoc') > classicData.indexOf('?') &&
                  classicData.indexOf('?') > -1
                ) {
                  if (
                    this.iframe.nativeElement.contentWindow.location.href.indexOf(
                      'adhoc'
                    ) > -1
                  ) {
                  } else {
                    flag = false;
                  }
                }
                if (
                  classicData.indexOf('conversations') >
                  classicData.indexOf('?') &&
                  classicData.indexOf('?') > -1
                ) {
                  if (
                    this.iframe.nativeElement.contentWindow.location.href.indexOf(
                      'conversations'
                    ) > -1
                  ) {
                  } else {
                    flag = false;
                  }
                }

                if (childRoute.path == 'informal-conversations') {
                  continue;
                }

                if (
                  childRoute.path == 'my-informal-conversations' &&
                  classicData.indexOf('viewgeneralcomment') > -1
                ) {
                  if (
                    this.iframe.nativeElement.contentWindow.location.href.indexOf(
                      'actor=self'
                    ) > -1
                  ) {
                  } else {
                    flag = false;
                  }
                }

                if (
                  childRoute.path == 'peer-informal-conversations' &&
                  classicData.indexOf('viewgeneralcomment') > -1
                ) {
                  if (
                    this.iframe.nativeElement.contentWindow.location.href.indexOf(
                      'actor=peer'
                    ) > -1
                  ) {
                  } else {
                    flag = false;
                  }
                }

                if (
                  childRoute.path == 'conversations/informal' &&
                  classicData.indexOf('viewgeneralcomment') > -1 &&
                  route.path == 'manager'
                ) {
                  if (
                    this.iframe.nativeElement.contentWindow.location.href.indexOf(
                      'actor=mgr'
                    ) > -1
                  ) {
                  } else {
                    flag = false;
                  }
                }

                if (classicData.indexOf('?') > -1) {
                  classicData = classicData.slice(0, classicData.indexOf('?'));
                }

                if (classicData === newFrameLocation && flag) {
                  let prefix = route.path + '/';

                  this._breadcrumbService.generateBreadcrumb(
                    '/' + prefix + childRoute.path
                  );
                  break;
                }
              } catch (e) {
                console.error(e);
              }
            }
          }
        }
      }
    }
  }

  private constructUrl(student: Student) {
    this._subscriptions.push(
      this.route.data.subscribe((data) => {
        let url = data.classicpath;

        if (url.indexOf('{studentid}') > -1) {
          url = url.replace('{studentid}', student.studentId.toString());
        }
        let isFirstKey = false;
        if (url.indexOf('?') === -1) {
          url += '?';
          isFirstKey = true;
        }

        for (const queryString of this.queryStringParams) {
          if (url.indexOf(queryString['key'] + '=' + queryString['value']) == -1) {
            if (isFirstKey && this.queryStringParams.indexOf(queryString) === 0) {
              url += '';
            } else {
              url += '&';
            }

            url += queryString['key'] + '=' + queryString['value'];
          }
        }

        // Clean unused parameters from QueryString
        if (url.indexOf('{') > -1) {
          const tempUrlQsParts = [];
          const queryStringValuesSplit = url.split('?')[1].split('&');

          for (const splitQsValue of queryStringValuesSplit) {
            if (splitQsValue.indexOf('{') === -1) {
              tempUrlQsParts.push(splitQsValue);
            }
          }

          url = url.split('?')[0] + '?' + tempUrlQsParts.join('&');
        }

        const isDelegatedRoute = <boolean>data.delegate;
        if (isDelegatedRoute) {
          const delegatedTeam = this._authService.getActiveDelegation();
          if (delegatedTeam && url.indexOf("studentid=" + delegatedTeam.studentId) == -1) {
            url += '&studentid=' + delegatedTeam.studentId;
          }
        }

        const urlFormatted =
          this._sanitizer.bypassSecurityTrustResourceUrl(url);

        if (this.iframelink !== url || this.newLoad) {
          this.newLoad = false;
          this.iframelinkSafe = urlFormatted;
          this.iframelink = url;
          this.iframeFirstLoad = true;
        }
      })
    );
  }

  ngOnDestroy(): void {
    for (const subscription of this._subscriptions) {
      subscription.unsubscribe();
    }
  }
}
